import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    render() {
        return (
            <tarot-question>
                {this.renderInputOrQuestion()}
            </tarot-question>
        );
    }

    renderInputOrQuestion = () => {
        if (this.props.sample_interps || this.props.fixed_question) {
            return (
                <p className='subject-set'>Your Question: {this.props.subject || 'Unspoken'}</p>
            );
        }

        return (
            <form onSubmit={this.submit} autoComplete='off'>
                <input
                    onFocus={this.clearQuestion}
                    onBlur={this.captureQuestion}
                    name='question'
                    type='text'
                    maxLength='140'
                    placeholder={this.props.placeholder || 'Enter your question or subject here (optional)'}
                    className={this.props.subject ? 'has-subject' : ''}
                />
            </form>
        );
    }

    submit = (e) => {
        e.preventDefault();
        return false;
    }

    captureQuestion = (e) => {
        const question = e.target.value || '';
        this.props.captureQuestion(question);
    }

    clearQuestion = (e) => {
        e.target.value = '';
        e.target.classList.remove('subject');
    }
}

const mapStateToProps = (state) => ({
    subject: state['tarot-reading'].subject,
    sample_interps: state['tarot-reading'].sample_interps,
    fixed_question: state['tarot-reading'].fixed_question,
});

const mapDispatchToProps = (dispatch) => ({
    captureQuestion: (question) => dispatch({ type: 'tarot-reading:update', payload: { subject: question }}),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
